export default {
  Title: "Add Role",
  rName: "Name",
  cName: "Company",
};
